import { fromJS } from "immutable";

import types from "./types";

import { RESET_VOTING_FORM } from "../types";

export const initialState = fromJS({
  section: {},
});

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case types.SET_PARENT_SECTION: {
      return state.set("section", action.section);
    }

    case types.RESET_PARENT_SECTION: {
      return initialState;
    }

    case RESET_VOTING_FORM: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};
